import { Article, ArticleImage, ArticleSubtitle, ArticleTitle } from "@babackapp/customer-ui/components/article";
import { Badge } from "@babackapp/customer-ui/components/badge";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import type { NonReturnableLineItem } from "@babackapp/return-widget-components/types";
import { formatVariantOptions } from "../../utils/format-variant-options";

type Props = { item: NonReturnableLineItem };

export function NonReturnableRow({ item }: Props) {
  const t = useCustomText();
  const { lineItem, reason } = item;
  const options = formatVariantOptions(lineItem);

  return (
    <Article className="opacity-50 cursor-not-allowed select-none">
      <ArticleImage src={lineItem.image} layoutId={`img-${lineItem.line_item_id}`} />
      <ArticleTitle>{lineItem.title}</ArticleTitle>
      {options && <ArticleSubtitle>{options}</ArticleSubtitle>}
      <Badge variant="secondary">
        {reason === "OUTSIDE_RETURN_WINDOW"
          ? t("articleSelection.outsideReturnWindow")
          : t("articleSelection.notReturnable")}
      </Badge>
    </Article>
  );
}
